/**
 * BrandMark — the small Opus logo: gradient frame + inner square + tiny gradient core.
 * Used in the top bar and on auth screens.
 */
import { cn } from "@/lib/cn";

export interface BrandMarkProps {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 30, className }: BrandMarkProps) {
  // Inset values are proportional to the outer size so the mark scales cleanly.
  const innerInset = Math.round(size * 0.2);
  const coreInset = Math.round(size * 0.3);
  return (
    <figure
      role="img"
      aria-label="Opus"
      className={cn("relative m-0 shrink-0 rounded-lg bg-aurora-grad shadow-primary-glow", className)}
      style={{ width: size, height: size, borderRadius: size * 0.3 }}
    >
      <div
        className="absolute bg-bg-0"
        style={{
          inset: innerInset,
          borderRadius: size * 0.16,
        }}
      />
      <div
        className="absolute bg-aurora-grad"
        style={{
          inset: coreInset,
          borderRadius: size * 0.1,
        }}
      />
    </figure>
  );
}
